import { API, baseClient } from "../index";

// Solicitud pública de eliminación de datos (/eliminar-datos).
// Responde siempre 200 genérico con un email válido.
export const postDataDeletionRequest = ({ email, tipo, language }) => {
  return baseClient().post(`${API}/privacy/deletion-request`, {
    email,
    tipo,
    language,
  });
};

// Confirmación con el token del email (un solo uso, 24 h).
// → { status: "completed" | "verified", tipo, alreadyConfirmed }
export const postDataDeletionConfirm = (token) => {
  return baseClient().post(`${API}/privacy/deletion-request/confirm`, { token });
};
